(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/module/assets/javascripts/filter.js') >= 0) return;  svs.modules.push('/components/core/module/assets/javascripts/filter.js'); "use strict";

var helpers = svs.core.module.helpers;
var loadedAssetsForRoutes = {};

function setAssetsLoadedForRoute(routeUrl) {
  loadedAssetsForRoutes[routeUrl] = true;
}

function isRouteLoaded(routeUrl) {
  if (loadedAssetsForRoutes[routeUrl]) {
    return true;
  }

  return false;
}

function getAssets(routeUrl, arg, callback) {
  var url;

  callback = callback || function () {};

  if (loadedAssetsForRoutes[routeUrl]) {
    helpers.logger.debug('Assets already loaded.', routeUrl);
    callback();
  } else {
    if (routeUrl.indexOf('{') > 0 && routeUrl.indexOf('}') > 0) {
      url = routeUrl.replace(/{.*}/, arg);
    } else {
      url = routeUrl;
    }

    helpers.logger.debug('Fetching assets.', url);
    svs.core.module.load(url, null, function () {
      loadedAssetsForRoutes[routeUrl] = true;
      callback();
    });
  }

  return svs.core.module;
}

svs.core.module.filter = {
  isRouteLoaded: isRouteLoaded,
  setAssetsLoadedForRoute: setAssetsLoadedForRoute,
  getAssets: getAssets
};
 })(window);